var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanada(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9969 15.721H18.8133L18.7969 0.920898H23.9805L23.9969 15.721Z",
    fill: "#E91E26",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20003 15.721H0.0164002L0 0.920898H5.18363L5.20003 15.721Z",
    fill: "#E91E26",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7993 15.721H5.24212L5.19922 0.920898H18.7564L18.7993 15.721Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8032 8.92122L16.0032 8.12122L16.6275 6.50231L14.8637 6.80171L14.5976 6.06991L13.2672 7.20081L13.7328 4.7394L12.9345 5.1053L12.0032 3.54199L11.0718 5.1053L10.2735 4.7394L10.7391 7.20081L9.40874 6.06991L9.14264 6.80171L7.37883 6.50231L8.00313 8.12122L7.20312 8.92122L9.84114 10.1944L9.60834 10.9262L12.0032 10.5935L14.398 10.9262L14.1652 10.1944L16.8032 8.92122Z",
    fill: "#E91E26",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0749V10.7793",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanada);
export default __webpack_public_path__ + "static/media/Canada.569a9f064812789ae18d89a88a3313d9.svg";
export { ForwardRef as ReactComponent };